import { render, staticRenderFns } from "./VEditor.vue?vue&type=template&id=5d9b3c80&"
import script from "./VEditor.vue?vue&type=script&lang=js&"
export * from "./VEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports